module.exports = __webpack_public_path__ + "dist/img/shares.8a8ab62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/shares.png
// module id = 140
// module chunks = 2